var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37876 20.2542V4.13672V4.13672C6.37876 3.5154 6.88244 3.01172 7.50376 3.01172H16.5038V3.01172C17.1251 3.01172 17.6288 3.5154 17.6288 4.13672V20.2542V20.2543C17.6288 20.6685 17.293 21.0043 16.8788 21.0043C16.7475 21.0043 16.6186 20.9698 16.5048 20.9044L12.1909 18.4235V18.4235C12.0751 18.357 11.9327 18.357 11.817 18.4235L7.50278 20.9043V20.9043C7.14375 21.1108 6.68524 20.9873 6.47867 20.6282C6.41321 20.5144 6.37876 20.3855 6.37875 20.2542H6.37876Z",
    stroke: "#B8BEC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.2caa19c4ab93e0759fea3ff11b728718.svg";
export { ForwardRef as ReactComponent };